import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

// Time to wait before updating the URL
export const DEBOUNCE_SEARCH_TIME = 800

const useDebouncedSearch = (reset: (searchParam: string) => void) => {
  // Extract query parameters
  const [searchParams] = useSearchParams()
  const querySearched = searchParams.get('search') || ''
  const [search, setSearch] = useState<string>(querySearched)

  const [debouncedSearch, setDebouncedSearch] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search)

      // Update the URL with the search query parameter
      const newSearchParams = new URLSearchParams(searchParams)
      newSearchParams.set('search', search)
      if (search === '') {
        newSearchParams.delete('search')
      }
      navigate({
        pathname: window.location.pathname,
        search: newSearchParams.toString(),
      })

      // Reset the search if the search query is different from the debounced search
      const shouldReset = search !== debouncedSearch
      if (shouldReset) {
        reset(search)
      }
    }, DEBOUNCE_SEARCH_TIME)

    return () => {
      clearTimeout(handler)
    }
  }, [search, navigate, searchParams, reset, debouncedSearch])

  return [search, setSearch, debouncedSearch] as const
}

export default useDebouncedSearch
